import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, LoadingSpinner } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';
import { useOktaQuery, Team } from '../data';
import { store } from '../store';

const TeamSelector = ({ team, onSelect, className, selectFirstOnLoad }) => {
    const { t: translate } = useTranslation();
    const { state: { user: loggedInUser } } = useContext(store);
    const nyyTeamId = 147;
    const isOffSeason = [0, 1, 2, 9, 10, 11].indexOf((new Date()).getMonth()) > -1;
    const userTeamId = isOffSeason ? null : loggedInUser?.Department?.TeamID;
    const userCanViewNYY = loggedInUser.Roles?.some((userRole) => ['nyfrontoffice', 'mjcoach', 'viewmjadvance', 'perfmgmt', 'perfanalyst']
        .includes(userRole.RoleName));

    const { data: options, status } = useOktaQuery(
        ['teamList'],
        (te) => Team.minormajor(te, nyyTeamId),
        {
            select: (teams) => teams.map((x) => ({ ...x, name: x.FullName, value: x.TeamID })),
            onSuccess: (result) => preSelect(result),
        },
    );

    function preSelect(teams) {
        if (selectFirstOnLoad && !team) {
            onSelect(teams[0]);
        }
        if (userTeamId) {
            onSelect(teams.filter((x) => x.TeamID === userTeamId)[0]);
        }
    }

    if (status === 'loading') {
        return <LoadingSpinner border="animation" className="float-end" />;
    }

    return (
        <Dropdown
            options={userCanViewNYY ? options : options.filter((x) => x.value !== nyyTeamId)}
            value={team}
            title={translate('common.select-a-team')}
            onSelect={onSelect}
            className={className}
            disabled={userTeamId}
        />
    );
};

TeamSelector.defaultProps = {
    team: undefined,
    className: '',
    selectFirstOnLoad: false,
};
TeamSelector.propTypes = {
    team: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({ name: PropTypes.string.isRequired, value: PropTypes.number }),
    ]),
    onSelect: PropTypes.func.isRequired,
    className: PropTypes.string,
    selectFirstOnLoad: PropTypes.bool,
};

export default TeamSelector;
